export interface EventFormValues {
	name: string;
	location: string;
	body: string;
	startDate: string;
	startTime: string;
	showStartDate: boolean;
	endDate: string;
	endTime: string;
	showEndDate: boolean;
	tag: string | null;
	/** Blob reference returned by the upload pipeline (null when no image set). */
	image: string | null;
	audienceGroupIds: number[];
}

// An empty TipTap editor emits `<p></p>` rather than `""`. Treat any HTML
// that strips to no visible text as cleared, so the adapter still produces
// `body: null` (matching the old textarea contract).
const normalizeBody = (html: string): string | null => {
	if (!html) return null;
	const text =
		typeof window !== "undefined" && window.DOMParser
			? (new DOMParser().parseFromString(html, "text/html").body.textContent ??
				"")
			: html.replace(/<[^>]*>/g, "");
	return text.trim().length === 0 ? null : html;
};

export function formValuesToEvent(
	data: EventFormValues,
	id?: number
): Partial<MeeEvent> {
	return {
		...(id !== undefined && { id }),
		name: data.name,
		location: data.location || null,
		body: normalizeBody(data.body),
		startDate: `${data.startDate}T${data.startTime || "00:00"}`,
		showStartDate: data.showStartDate,
		endDate: `${data.endDate}T${data.endTime || "00:00"}`,
		showEndDate: data.showEndDate,
		tag: data.tag
	};
}
